export default "__VITE_ASSET__Nn1yUuhk__"